import React, { useEffect, useState } from "react";
import { Api_Url } from "../../../config/config";
import axios from "axios";
import { Button, Modal, Table } from "antd";
import { MdCancel } from "react-icons/md";
import { FaUpload } from "react-icons/fa6";
import { Link } from "react-router-dom";
import { ErrorToast, SuccessToast } from "../../../views/ToastComponent";

const Vegetable = ({ ProfileId, profileId, commingIds }) => {
  console.log("comming", commingIds)
  const [allBusinessPd, setAllBusinessPd] = useState([]);
  const [areaType, setAreaType] = useState([]);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [ItemDataId, setItemDataId] = useState(0);

  const [garageAutoData, setGarageAutoData] = useState({
    name: "", businessPdProfileId: ProfileId, latitude: "", longitude: "", profitMarginId: 0, WorkingDays: 0, ShopImageUrl: null
  });

  const columns = [
    {
      title: "Name of Shop",
      dataIndex: "name",
      sorter: (a, b) => a.name.length - b.name.length,
    },
    {
      title: "Area Type",
      dataIndex: "profitMarginName",
      sorter: (a, b) => a.profitMarginName.length - b.profitMarginName.length,
    },
    {
      title: "Working Days",
      dataIndex: "workingDays",
      sorter: (a, b) => a.workingDays.length - b.workingDays.length,
    },
    {
      title: "Created At",
      dataIndex: "created",
      render: (text) => {
        return new Date(text).toLocaleDateString() + "   " + new Date(text).toLocaleTimeString();
      },
      sorter: (a, b) => a.created.length - b.created.length,
    },
    {
      title: "Actions",
      dataIndex: "actions",
      render: (text, record) => (
        <Link to={`vegetablesdetails/${record.id}`}><Button>View Details</Button></Link>
      ),
    },
    {
      title: 'Edit',
      dataIndex: 'edit',
      render: (text, record) => (
        <div>
          {text}
          <Button
            type="primary"
            onClick={() => handleClick(record.id)}
            style={{ marginLeft: '10px' }}
          >
            <i className="fa-solid fa-pen-to-square"></i>
          </Button>
        </div>
      ),
    },
  ];

  const handleImageChange = event => {
    setGarageAutoData(prev => ({
      ...prev,
      ShopImageUrl: event.target.files[0]
    }))
  };

  const fetchIncomeData = async () => {
    const { data } = await axios.get(`${Api_Url}api/v1/Vegetable/getbybusinesspdprofileid/${commingIds.BusinessPdProfileId}`, {
      headers: {
        Authorization: `Bearer ${JSON.parse(sessionStorage.getItem("user"))?.accessToken}`
      }
    });
    console.log("fetch", data)
    setAllBusinessPd(data);
  };

  const fetchAreaType = async () => {
    try {
      const { data } = await axios.get(`${Api_Url}api/v1/ProfitMargin/getbyprofileid/${ProfileId}`, {
        headers: {
          Authorization: `Bearer ${JSON.parse(sessionStorage.getItem("user"))?.accessToken}`
        }
      });
      setAreaType(data.data);
    } catch (error) {
      console.log(error);
    }
  };

  const fetchCurentLocation = () => {
    if ("geolocation" in navigator) {
      navigator.geolocation.getCurrentPosition(function (position) {
        const { latitude, longitude } = position.coords;
        setGarageAutoData(prev => ({ ...prev, latitude: latitude.toString(), longitude: longitude.toString() }))
      });
    } else {
      return "Geolocation is not supported by this browser."
    }
  };

  const handleSubmit = async (operationType) => {
    if (!garageAutoData.ShopImageUrl) {
      ErrorToast("Please select an image");
      return;
    }

    try {
      const formData = new FormData();

      formData.append("BusinessPdProfileId", commingIds.BusinessPdProfileId)
      formData.append("ProfitMarginId", garageAutoData.profitMarginId)
      formData.append("Name", garageAutoData.name)
      formData.append("WorkingDays", garageAutoData.WorkingDays)
      formData.append("ShopImageUrl", garageAutoData.ShopImageUrl)
      formData.append("Latitude", garageAutoData.latitude)
      formData.append("Longitude", garageAutoData.longitude)

      if (operationType === "Submit") {
        await axios.post(`${Api_Url}api/v1/Vegetable`, formData, {
          headers: {
            Authorization: `Bearer ${JSON.parse(sessionStorage.getItem("user"))?.accessToken}`,
            "Content-Type": "multipart/form-data",
          }
        });
      } else {
        formData.append("Id", ItemDataId);
        await axios.put(`${Api_Url}api/v1/Vegetable/${ItemDataId}`, formData, {
          headers: {
            Authorization: `Bearer ${JSON.parse(sessionStorage.getItem("user"))?.accessToken}`
          }
        });
      }
      fetchIncomeData();
      setGarageAutoData({
        name: "", businessPdProfileId: profileId, profitMarginId: 0, WorkingDays: 0, ShopImageUrl: null
      });
      setIsModalOpen(false);
      setItemDataId(0);
      SuccessToast("Added Succefully")
    } catch (error) {
      ErrorToast("Something went wrong")
      console.log(error);
    }
  };

  const handleClick = async (id) => {
    setItemDataId(id);
    await LoadSingleAutoDriver(id);
    setIsModalOpen(true);
  };

  const LoadSingleAutoDriver = async (hereId) => {
    try {
      const response = await axios.get(`${Api_Url}api/v1/Vegetable/${hereId}`, {
        headers: {
          Authorization: `Bearer ${JSON.parse(sessionStorage.getItem("user")).accessToken}`
        }
      });
      console.log("🥰🥰🥰😍😎", response.data.data);
      setGarageAutoData({
        name: response.data.data.name,
        businessPdProfileId: response.data.data.businessPdProfileId,
        profitMarginId: response.data.data.profitMarginId,
        ShopImageUrl: response.data.data.shopImageUrl,
        WorkingDays: response.data.data.workingDays,
      });
    } catch (e) {
      console.log("Load Single Auto Driver", e.message);
    }
  };

  const handleCancel = () => {
    setGarageAutoData({
      name: "", businessPdProfileId: profileId, latitude: "", longitude: "", profitMarginId: 0, WorkingDays: 0, ShopImageUrl: null
    });
    setItemDataId(0);
    setIsModalOpen(false);
  };

  useEffect(() => {
    fetchIncomeData();
    fetchAreaType();
    fetchCurentLocation();
  }, []);

  return (
    <div className="container mt-3">
      <div className="row">
        <div className="col-12 d-flex align-items-center justify-content-between">
          <h3 className="mb-0">Vegetable</h3>
          <button className="btn btn-primary submit-btn" onClick={() => { setIsModalOpen(true); setItemDataId(0); }}>Add Vegetable</button>
        </div>
      </div>

      <div className="row mt-4">
        <div className="col-12 mx-auto">
          <Table
            className="table-striped bg-white"
            style={{ overflowX: "auto" }}
            columns={columns}
            dataSource={allBusinessPd}
            rowKey={(record) => record.id}
          />
        </div>
      </div>

      {/* Garage Auto Form */}
      <Modal
        title={<h4>{ItemDataId == 0 ? "Add" : "Edit"} Cart/Shop</h4>}
        open={isModalOpen}
        centered
        onOk={() => setIsModalOpen(false)}
        onCancel={handleCancel}
        footer={[
          <div className='d-flex justify-content-between align-items-center'>
          <button key="Cancel" className="btn btn-danger submit-btn" type="button" onClick={handleCancel}>Cancel</button>,
          <button key="submit" className="btn btn-primary submit-btn" type="submit" onClick={() => handleSubmit(ItemDataId === 0 ? "Submit" : "Edit")}>{ItemDataId === 0 ? "Submit" : "Update"}</button>
          </div>
        ]}
        width={600}
        mask={false}
        maskClosable={false}
        closeIcon={<span style={{ color: 'red' }}>X</span>}
      >
        <div className="modal-body mt-5">
          <form>
            <div className="row">
              <div className="col-sm-6">
                <div className="input-block mb-3">
                  <label className="col-form-label">
                    Name of Cart/Shop
                  </label>
                  <input className="form-control" type="text" value={garageAutoData.name} onChange={(e) => setGarageAutoData({ ...garageAutoData, name: e.target.value })} />
                </div>
              </div>
              <div className="col-sm-6">
                <div className="input-block mb-3">
                  <label className="col-form-label">Area Type</label>
                  <select className="form-select" onChange={(e) => setGarageAutoData({ ...garageAutoData, profitMarginId: Number(e.target.value) })} value={garageAutoData.profitMarginId}>
                    <option value={0} disabled>Select Area Type</option>
                    {areaType.map((item) => (
                      <option key={item.id} value={item.id}>{item.name}</option>
                    ))}
                  </select>
                </div>
              </div>
              <div className="col-sm-6">
                <div className="input-block mb-3">
                  <label className="col-form-label">Working Days</label>
                  <input className="form-control" type="number" value={garageAutoData.WorkingDays} onChange={(e) => setGarageAutoData({ ...garageAutoData, WorkingDays: e.target.value })} />
                </div>
              </div>
              <div className="col-sm-12">
                <input type="file" name="" accept="image/*" id="upload-image" onChange={handleImageChange} hidden />
                {
                  garageAutoData.ShopImageUrl !== null ? <p className="border mb-0 px-2 py-1 rounded d-flex align-items-center gap-1">
                    {garageAutoData?.ShopImageUrl?.name} <MdCancel size={20} onClick={() => setGarageAutoData(prev => ({ ...prev, ShopImageUrl: null }))} />
                  </p> : <label htmlFor="upload-image" className="">
                    <p className="border mb-0 px-2 py-1 rounded d-flex align-items-center gap-1">
                      <FaUpload size={20} /> Click to Upload
                    </p>
                  </label>
                }
              </div>
            </div>
          </form>
        </div>
      </Modal>
    </div>
  );
}

export default Vegetable;
